module.exports = __webpack_public_path__ + "img/speaker3.png?f1e45149baff389ea7355a6da8fb91a2";